<!-- src/components/NotesView.vue -->

<template>
    <section class="notes">
        <div class="hidden md:flex pt-2.5 px-0 pb-1">
            <div class="flex-grow">
                <h3 class="tracking-normal text-cal-4A4A4A my-2.5 mx-0 font-bold text-xl">Notes</h3>
            </div>
            <div class="flex-shrink"></div>
        </div>
        
        <search-bar 
            v-model="query"
            v-on:search="onSearch"
            placeholder="Search for notes"></search-bar>
        
        <vue-tabs>
            <div class="tab" title="Projects">
                
                <article class="note-entry" @click="onClickProject(note)" v-for="note in projectNotes.rows">
                    <h3 class="note-entry-title">{{ note.project.title }}</h3>
                    <span class="note-entry-subtitle">{{ note.project.id }}</span>
                    <span class="note-entry-subtitle">{{ note.project.city }}, {{ note.project.state }}</span>
                    <span class="note-entry-date">{{ note.created_at | moment("MM/DD/YYYY") }}</span>
                    <p class="note-entry-body">{{ note.note }}</p>
                </article>
    
                <vue-table-pagination 
                    :total-rows="projectNotes.totalRows"
                    :per-page="projectNotes.params.perPage"
                    :current-page="projectNotes.params.page"
                    v-on:selected-page="onSelectProjectPage"></vue-table-pagination>
            </div>
            <div class="tab" title="Contact">
                
                <article class="note-entry" @click="onClickContact(note)" v-for="note in contactNotes.rows">
                    <h3 class="note-entry-title">{{ note.contact.first_name }} {{ note.contact.last_name }}</h3>
                    <span class="note-entry-subtitle">{{ note.contact.company_name }}</span>
                    <span class="note-entry-subtitle">{{ note.contact.city }}, {{ note.contact.state }}</span>
                    <span class="note-entry-date">{{ note.created_at | moment("MM/DD/YYYY") }}</span>
                    <p class="note-entry-body">{{ note.note }}</p>
                </article>
                
                <vue-table-pagination 
                    :total-rows="contactNotes.totalRows"
                    :per-page="contactNotes.params.perPage"
                    :current-page="contactNotes.params.page"
                    v-on:selected-page="onSelectContactPage"></vue-table-pagination>
            </div>
        </vue-tabs>
    </section>
</template>

<script>
    
import NoteEntry from '../Shared/NoteEntry.vue';
import SearchBar from '../Shared/SearchBar.vue';
import WebServices from '../../services/WebServices';
import VueButton from '../Shared/VueButton.vue';
import VueTabs from '../Shared/VueTabs.vue';
import VueTablePagination from '../Shared/VueTablePagination.vue';

export default {
    
    components: { NoteEntry, VueButton, VueTabs, SearchBar, VueTablePagination },
    
    data () {
        return {
            notesServices: WebServices('Notes'),
            query: "",
            contactNotes: {
                rows: [],
                totalRows: 0,
                params: {
                    query: "",
                    page: 1,
                    perPage: 15,
                    orderBy: null,
                    orderDirection: null
                }
            },
            projectNotes: {
                rows: [],
                totalRows: 0,
                params: {
                    query: "",
                    page: 1,
                    perPage: 15,
                    orderBy: null,
                    orderDirection: null
                }
            }
        }
    },
    
    created () {
        this.getAll();
    },
    
    methods: {
        
        getAll() {
            this.getContacts();
            this.getProjects();
        },
        
        getContacts () {
            
            this.notesServices
                .getAll(this.contactNotes.params, "Contacts")
                .then(function(response) {
                    var properties = response.data.data;
                    this.contactNotes.totalRows = properties.total;
                    this.contactNotes.rows = properties.data;
                }.bind(this));
        },
        
        getProjects () {
            
            this.notesServices
                .getAll(this.projectNotes.params, "Projects")
                .then(function(response) {
                    var properties = response.data.data;
                    this.projectNotes.totalRows = properties.total;
                    this.projectNotes.rows = properties.data;
                }.bind(this));
        },
        
        onSearch () {
            
            this.projectNotes.params.query = this.query;
            this.contactNotes.params.query = this.query;
            this.getAll();
        },
        
        onClickProject (note) {
            
            this.$router.push({ name: 'projects.show', params : { projectId: note.project.id, row: note.project } });
        },
        
        onClickContact (note) {
            
            this.$router.push({ name: 'contacts.show', params : { contactId: note.contact.id, row: note.contact } });
        },
        
        onSelectProjectPage (page) {
            this.projectNotes.params.page = page;
            this.getProjects();
        },
        
        onSelectContactPage (page) {
            this.contactNotes.params.page = page;
            this.getContacts();
        }
    },
}

</script>

<style>
.notes {
    font-family: var(--font-family);
    font-weight: 500;
}

.note-entry {
    padding: 20px;
    border-bottom: 1px solid #E8E8E8;
}

.note-entry:hover {
    background: #EBF8F0;
    cursor: pointer;
}

.note-entry-title {
    font-weight: 500;
    font-size: 14px;
    color: #4A4A4A;
    letter-spacing: 0;
    padding-bottom: 2px;
    margin: 0px;
}

.note-entry-subtitle {
    font-size: 12px;
    color: #4A4A4A;
    letter-spacing: 0;
    display: block;
}

.note-entry-date {
    display: block;
    font-size: 14px;
    color: rgba(73,73,73,0.50);
    letter-spacing: 0;
    margin-top: 15px;
}

.note-entry-body {
    font-size: 14px;
    color: #4A4A4A;
    line-height: 19px;
    margin: 0px;
}
</style>

